var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameBanner && _vm.gameBanner.game)?_c('div',{staticClass:"game-banner",on:{"click":function($event){_vm.openGame(_vm.gameBanner.game)}}},[(_vm.gameBanner.img)?_c('img',{staticClass:"game-banner__img",attrs:{"src":_vm.gameBanner.img,"alt":_vm.gameBanner.category}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/common/banners/game-banners/game-banner.vue?vue&type=template&id=f21a3862
// module id = JeL0
// module chunks = 0